import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-navtoggle', 'toggleMenu', 'Toggle menu');
Labels.set('ui-navtoggle', 'closeMenu', 'Close menu');
Labels.set('ui-navtoggle', 'close', 'Close');
